module.exports = __webpack_public_path__ + "img/mobile/Background-freespins/fsbackground@2x.jpg?1.0.17";